import styles from "./Signals.module.css";

const SignalsComponent = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Подаване на сигнали по ЗЗЛПСПОИН</h1>

      <div>
        <h2>ИНФОРМАЦИЯ ЗА УСЛОВИЯТА И РЕДА ЗА ВЪТРЕШНО ПОДАВАНЕ НА СИГНАЛИ</h2>
        <p>
          Настоящата информация се предоставя в изпълнение на чл. 12, ал. 4 от
          Закона за защита на лицата, подаващи сигнали или публично оповестяващи
          информация за нарушения, обнародван в ДВ, бр. 11 от 2 февруари 2023
          г., в сила от 4 май 2023 г. („ЗЗЛПСПОИН“).
        </p>
      </div>

      <div>
        <h2>1. Кой има право да подава сигнали?</h2>
        <ul>
          <li>настоящи или бивши работници и служители;</li>
          <li>лица, работещи по граждански договор;</li>
          <li>лица, упражняващи свободни професии или занаятчийска дейност;</li>
          <li>доброволци и стажанти;</li>
          <li>изпълнители, подизпълнители или доставчици;</li>
          <li>
            кандидати за работа или участници в конкурси за заемане на
            определена длъжност;
          </li>
          <li>
            всички лица, на които в работен контекст им е станала известна
            информация за нарушения.
          </li>
        </ul>
        <p>Важно! Анонимни сигнали НЕ се разглеждат.</p>
      </div>

      <div>
        <h2>2. За какви нарушения можете да подавате сигнали?</h2>
        <p>
          За нарушения, които засягат обществен интерес на българското и
          европейското законодателство в различни области, сред които:
        </p>
        <ul>
          <li>обществените поръчки;</li>
          <li>общественото здраве;</li>
          <li>безопасността на транспорта;</li>
          <li>защитата на потребителите;</li>
          <li>
            защитата на неприкосновеността на личния живот и личните данни;
          </li>
          <li>сигурността на мрежите и информационните системи;</li>
          <li>нарушения, свързани с транс гранични данъчни схеми;</li>
          <li>извършено престъпление от общ характер;</li>
          <li>трудовото законодателство;</li>
          <li>
            законодателството, свързано с изпълнението на държавна служба;
          </li>
          <li>
            правилата за заплащане на дължими публични държавни и общински
            вземания и други области, посочени в ЗЗЛПСПОИН.
          </li>
        </ul>
        <p>
          Важно! Не се разглеждат сигнали за нарушения, които не попадат в
          обхвата на ЗЗЛПСПОИН, както и сигнали, извършени преди повече от две
          години.
        </p>
      </div>

      <div>
        <h2>3. Как можете да подадете сигнал до „КЛАСИК-2000“ ООД?</h2>
        <p>
          Може да подадете писмен сигнал чрез попълване на формуляр по образец
          (можете да изтеглите от тук), по някой от следните начини:
        </p>
        <ul>
          <li>лично, на нашия служител, отговарящ за сигналите;</li>
          <li>по електронен път, като го изпратите до следния e-mail: </li>
          <li>
            по пощата или чрез куриерска услуга – на адреса на „КЛАСИК-2000“ ООД
            с изрично посочване като адресат на пощенската/куриерската пратка
            отговорното лице по ЗЗЛПСПОИН или изписване върху пощенския
            плик/куриерската пратка на текст, който посочва, че те съдържат
            сигнал по ЗЗЛПСПОИН с гриф “ПОВЕРИТЕЛНО“.
          </li>
        </ul>
        <p>
          Важно! Сигналите трябва да са подписани от лицата, които ги подават.
          При подаване по електронен път, формулярът се подписва с квалифициран
          електронен подпис.
        </p>
        <p>
          Важно! Формулярът НЕ е задължителен, а е за Ваше улеснение и съдържа
          задължителните данни, която трябва да попълните. Ако Вашият сигнал не
          отговаря на някое от законовите изисквания, нашият служител, отговарящ
          за сигналите, ще Ви изпрати съобщение за отстраняване на допуснатите
          нередовности в 7-дневен срок от получаване на сигнала. Ако
          нередовностите не бъдат отстранени в този срок, сигналът заедно с
          приложенията към него ще Ви бъдат върнати.
        </p>
        <p>
          Добре е да приложите всички писмени доказателства, с които
          разполагате. Също така, може да посочете лица, който биха могли да
          потвърдят съобщените данни или да представят допълнителна информация.
        </p>
        <p>Може да подадете устен сигнал по някой от следните начини:</p>
        <ul>
          <li>на телефона на нашия служител,</li>
          <li>отговарящ за регистриране на сигналите +359 886508717,</li>
          <li>
            заместник отговарящ за регистриране на сигналите +359 883338181
          </li>
          <li>
            на лична среща с нашия служител, отговарящ за сигналите, която сте
            уговорили предварително на посочения телефон,
          </li>
          <li>
            на адрес: гр. Видин, п.к. 3700, ул. Рибарска № 10, ет.2, ст.1.
          </li>
        </ul>
        <p>
          В тези случаи нашият служител, отговарящ за сигналите, ще попълни
          данните във формуляра по образец и ще Ви даде възможност да проверите,
          коригирате и да се съгласите с текста от разговора в писмен вид, както
          и със съдържанието на формуляра като ги подпишете.
        </p>
      </div>

      <div>
        <h2>4. Какво се случва след подаване на сигнала?</h2>
        <p>
          Ние ще потвърдим получаването му в срок до 7 дни и ще го регистрираме
          с уникален идентификационен номер. Ако сигналът не отговаря на
          изисквания на закона, ще Ви уведомим да отстраните нередовността в
          7-дневен срок.
        </p>
        <p>
          Ще бъде извършена проверка по сигнала от лице, което не е в конфликт
          на интереси.
        </p>
        <p>
          В срок до три месеца от потвърждаване на получаването на сигнала, ще
          Ви предоставим обратна информация с резултатите от проверката и
          предприетите действия.
        </p>
      </div>

      <div>
        <h2>5. Каква защита имат лицата, подаващи сигнали?</h2>
        <p>
          Лицата, които имат право да подават сигнали, както и свързаните с тях
          лица (напр. колеги и роднини), са защитени срещу неоснователно
          разкриване на самоличността им, освен в позволените от закона случаи.
        </p>
        <p>
          Забранено е предприемане на ответни мерки срещу защитените лица, а
          именно: временно отстраняване от работа, уволнение, понижаване в
          длъжност, отрицателна оценка за работата, прилагане на имуществена и
          дисциплинарна отговорност, физическа и словесна принуда, заплаха,
          враждебност и накърняване на достойнството им, дискриминация и др.
        </p>
      </div>

      <div>
        <h2>6. Какви са условията за предоставяне на защита?</h2>
        <p>
          Лицето, подаващо сигнал, трябва да има основателна причина да счита,
          че подадената информация за нарушението в сигнала е била вярна към
          момента на подаването и че тази информация попада в приложното поле на
          ЗЗЛПСПОИН; и Сигналът за нарушение е подаден при условията и по реда
          на ЗЗЛПСПОИН.
        </p>
        <p>
          Важно! Лицата, посочени в сигнала като нарушители, имат право на
          обезщетение за всички имуществени и не имуществени вреди, когато е
          установено, че сигнализиращото лице съзнателно е подало сигнал с
          невярна информация.
        </p>
      </div>

      <div>
        <h2>
          7. Как можете да подадете сигнал до КОМИСИЯТА ЗА ЗАЩИТА НА ЛИЧНИТЕ
          ДАННИ?
        </h2>
        <p>
          Комисията за защита на личните данни е Централният орган за външно
          подаване на сигнали. Можете да подадете своя сигнал и директно до нея
          по един от следните начини:
        </p>
        <p>писмено:</p>
        <ul>
          <li>на e-mail: whistleblowing@cpdp.bg</li>
          <li>
            по пощата на адрес: гр. София 1592, бул. „Проф. Цветан Лазаров” № 2
          </li>
          <li>чрез Системата за сигурно електронно връчване</li>
        </ul>
        <p>устно:</p>
        <ul>
          <li>
            на място в КЗЛД на адрес: гр. София 1592, бул. „Проф. Цветан
            Лазаров” № 2
          </li>
        </ul>
        <p>
          Бихте могли да използвате на образеца на Формуляр за регистриране на
          сигнал за подаване на информация за нарушения, който може да се
          изтегли от сайта на КЗЛД. Формулярът не е задължителен. В случай че
          решите да го използвате обаче, трябва да попълните само Част I – V
          включително и да го подпишете:
        </p>
        <ul>
          <li>при изпращане на формуляра по пощата – със саморъчен подпис;</li>
          <li>
            при изпращане по електронна поща – с квалифициран електронен подпис.
          </li>
        </ul>
        <p>
          Ако ползвате Системата за сигурно електронно връчване служителят на
          КЗЛД, отговарящ за разглеждането на сигнала, ще установи контакт с Вас
          с цел попълване на Формуляр за регистриране на сигнал за подаване на
          информация за нарушения съгласно ЗЗЛПСПОИН.
        </p>
      </div>
    </div>
  );
};

export default SignalsComponent;
